<template>
  <slide class="slide-wrapper">
    <div class="slide-content-wrapper"><slot></slot></div>
  </slide>
</template>

<script>
export default {
  name: "app-gallery-slide",
  props: {
    code: {
      type: String
    },
    thumbFormats: {
      type: String
    },
    thumbSizes: {
      type: String
    },
    description: {
      type: String
    },
    title: {
      type: String
    },
    carousel: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    baseUrl() {
      return "/app-static/uploads";
    },
    codes() {
      return this.code.split(";");
    },
    formats() {
      return this.thumbFormats.split(";");
    },
    sizes() {
      return this.thumbSizes.split(",");
    },
    images() {
      const images = [];

      this.codes.forEach((code, index) => {
        const image = {};
        image.code = code;
        image.thumbFormats = this.formats[index];
        image.thumbSizes = this.sizes[index];
        images.push(image);
      });

      return images;
    }
  },
  methods: {
    getUrl(size, format) {
      // return ${baseUrl}/${code}_${size}.${format}
    }
  }
};
</script>

<style scoped lang="scss">
.slide-wrapper {
  position: relative;
  overflow: hidden;
  padding-top: 56.25%;

  .slide-content-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
}
</style>
